module.exports = __webpack_public_path__ + "img/display-fill.d3e34744.svg";